import { GoogleOAuthProvider } from '@react-oauth/google';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OAuthGoogleButtonContent } from './oauth-google-button-content';

// Nova forma de logar com o Google
// https://livefiredev.com/in-depth-guide-sign-in-with-google-in-a-react-js-application/

function OAuthGoogleButton({
  logo,
  analytics,
  accountAPI,
  config,
  onLoggedIn,
  onErrorMessage,
  children,
  visible = true,
}) {
  const [loaded, setLoaded] = useState(false);
  const { t } = useTranslation();

  const onScriptLoadSuccess = () => {
    setLoaded(true);
  };

  const onScriptLoadError = () => {
    setLoaded(false);
    onErrorMessage?.call(this, t('oauth.button.google.error'));
  };

  return (
    <GoogleOAuthProvider
      clientId={config.auth?.google?.client_id}
      onScriptLoadSuccess={onScriptLoadSuccess}
      onScriptLoadError={onScriptLoadError}
    >
      {visible && (
        <OAuthGoogleButtonContent
          logo={logo}
          loaded={loaded}
          analytics={analytics}
          accountAPI={accountAPI}
          onLoggedIn={onLoggedIn}
          onErrorMessage={onErrorMessage}
        >
          {children}
        </OAuthGoogleButtonContent>
      )}
    </GoogleOAuthProvider>
  );
}

export { OAuthGoogleButton };
